module.exports = __webpack_public_path__ + "static/media/index.5acd1499.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/selectCategoryModule/index.scss
// module id = 512
// module chunks = 0